/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateCustomerBody,
  Customer,
  Error,
  GetCustomers200,
  GetCustomersParams,
  UpdateCustomerBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Create a new customer for use in invoices.
Store customer details including name, address, and tax information.
All fields except name are optional.
 * @summary Create a new customer
 */
export type createCustomerResponse201 = {
  data: Customer
  status: 201
}

export type createCustomerResponse400 = {
  data: Error
  status: 400
}

export type createCustomerResponse401 = {
  data: Error
  status: 401
}

export type createCustomerResponse403 = {
  data: Error
  status: 403
}

export type createCustomerResponse404 = {
  data: Error
  status: 404
}

export type createCustomerResponse422 = {
  data: ValidationError
  status: 422
}

export type createCustomerResponse500 = {
  data: Error
  status: 500
}

export type createCustomerResponseSuccess = (createCustomerResponse201) & {
  headers: Headers;
};
export type createCustomerResponseError = (createCustomerResponse400 | createCustomerResponse401 | createCustomerResponse403 | createCustomerResponse404 | createCustomerResponse422 | createCustomerResponse500) & {
  headers: Headers;
};

export type createCustomerResponse = (createCustomerResponseSuccess | createCustomerResponseError)

export const getCreateCustomerUrl = () => {


  

  return `/customers`
}

export const createCustomer = async (createCustomerBody: CreateCustomerBody, options?: RequestInit): Promise<createCustomerResponse> => {
  
  return customFetch<createCustomerResponse>(getCreateCustomerUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCustomerBody,)
  }
);}
  

/**
 * Retrieve a paginated list of customers with optional filtering and sorting.
Supports cursor-based pagination, flexible JSON querying with MongoDB-style operators, full-text search, and sorting.
 * @summary List all customers
 */
export type getCustomersResponse200 = {
  data: GetCustomers200
  status: 200
}

export type getCustomersResponse400 = {
  data: Error
  status: 400
}

export type getCustomersResponse401 = {
  data: Error
  status: 401
}

export type getCustomersResponse403 = {
  data: Error
  status: 403
}

export type getCustomersResponse404 = {
  data: Error
  status: 404
}

export type getCustomersResponse500 = {
  data: Error
  status: 500
}

export type getCustomersResponseSuccess = (getCustomersResponse200) & {
  headers: Headers;
};
export type getCustomersResponseError = (getCustomersResponse400 | getCustomersResponse401 | getCustomersResponse403 | getCustomersResponse404 | getCustomersResponse500) & {
  headers: Headers;
};

export type getCustomersResponse = (getCustomersResponseSuccess | getCustomersResponseError)

export const getGetCustomersUrl = (params?: GetCustomersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/customers?${stringifiedParams}` : `/customers`
}

export const getCustomers = async (params?: GetCustomersParams, options?: RequestInit): Promise<getCustomersResponse> => {
  
  return customFetch<getCustomersResponse>(getGetCustomersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve a single customer by its unique identifier.
Returns the complete customer details including name, address, and tax information.
 * @summary Get customer by ID
 */
export type getCustomerByIdResponse200 = {
  data: Customer
  status: 200
}

export type getCustomerByIdResponse401 = {
  data: Error
  status: 401
}

export type getCustomerByIdResponse403 = {
  data: Error
  status: 403
}

export type getCustomerByIdResponse404 = {
  data: Error
  status: 404
}

export type getCustomerByIdResponse500 = {
  data: Error
  status: 500
}

export type getCustomerByIdResponseSuccess = (getCustomerByIdResponse200) & {
  headers: Headers;
};
export type getCustomerByIdResponseError = (getCustomerByIdResponse401 | getCustomerByIdResponse403 | getCustomerByIdResponse404 | getCustomerByIdResponse500) & {
  headers: Headers;
};

export type getCustomerByIdResponse = (getCustomerByIdResponseSuccess | getCustomerByIdResponseError)

export const getGetCustomerByIdUrl = (id: string,) => {


  

  return `/customers/${id}`
}

export const getCustomerById = async (id: string, options?: RequestInit): Promise<getCustomerByIdResponse> => {
  
  return customFetch<getCustomerByIdResponse>(getGetCustomerByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update an existing customer.
Only the provided fields will be updated.
All fields are optional for partial updates.
 * @summary Update a customer
 */
export type updateCustomerResponse200 = {
  data: Customer
  status: 200
}

export type updateCustomerResponse400 = {
  data: Error
  status: 400
}

export type updateCustomerResponse401 = {
  data: Error
  status: 401
}

export type updateCustomerResponse403 = {
  data: Error
  status: 403
}

export type updateCustomerResponse404 = {
  data: Error
  status: 404
}

export type updateCustomerResponse422 = {
  data: ValidationError
  status: 422
}

export type updateCustomerResponse500 = {
  data: Error
  status: 500
}

export type updateCustomerResponseSuccess = (updateCustomerResponse200) & {
  headers: Headers;
};
export type updateCustomerResponseError = (updateCustomerResponse400 | updateCustomerResponse401 | updateCustomerResponse403 | updateCustomerResponse404 | updateCustomerResponse422 | updateCustomerResponse500) & {
  headers: Headers;
};

export type updateCustomerResponse = (updateCustomerResponseSuccess | updateCustomerResponseError)

export const getUpdateCustomerUrl = (id: string,) => {


  

  return `/customers/${id}`
}

export const updateCustomer = async (id: string,
    updateCustomerBody: UpdateCustomerBody, options?: RequestInit): Promise<updateCustomerResponse> => {
  
  return customFetch<updateCustomerResponse>(getUpdateCustomerUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCustomerBody,)
  }
);}
  

/**
 * Soft delete a customer by its unique identifier. The customer is moved to the trash and can be restored.
 * @summary Delete a customer
 */
export type deleteCustomerResponse204 = {
  data: void
  status: 204
}

export type deleteCustomerResponse400 = {
  data: Error
  status: 400
}

export type deleteCustomerResponse401 = {
  data: Error
  status: 401
}

export type deleteCustomerResponse403 = {
  data: Error
  status: 403
}

export type deleteCustomerResponse404 = {
  data: Error
  status: 404
}

export type deleteCustomerResponse422 = {
  data: ValidationError
  status: 422
}

export type deleteCustomerResponse500 = {
  data: Error
  status: 500
}

export type deleteCustomerResponseSuccess = (deleteCustomerResponse204) & {
  headers: Headers;
};
export type deleteCustomerResponseError = (deleteCustomerResponse400 | deleteCustomerResponse401 | deleteCustomerResponse403 | deleteCustomerResponse404 | deleteCustomerResponse422 | deleteCustomerResponse500) & {
  headers: Headers;
};

export type deleteCustomerResponse = (deleteCustomerResponseSuccess | deleteCustomerResponseError)

export const getDeleteCustomerUrl = (id: string,) => {


  

  return `/customers/${id}`
}

export const deleteCustomer = async (id: string, options?: RequestInit): Promise<deleteCustomerResponse> => {
  
  return customFetch<deleteCustomerResponse>(getDeleteCustomerUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Restore a soft-deleted customer from the trash.
 * @summary Restore a deleted customer
 */
export type restoreCustomerResponse200 = {
  data: Customer
  status: 200
}

export type restoreCustomerResponse400 = {
  data: Error
  status: 400
}

export type restoreCustomerResponse401 = {
  data: Error
  status: 401
}

export type restoreCustomerResponse403 = {
  data: Error
  status: 403
}

export type restoreCustomerResponse404 = {
  data: Error
  status: 404
}

export type restoreCustomerResponse422 = {
  data: ValidationError
  status: 422
}

export type restoreCustomerResponse500 = {
  data: Error
  status: 500
}

export type restoreCustomerResponseSuccess = (restoreCustomerResponse200) & {
  headers: Headers;
};
export type restoreCustomerResponseError = (restoreCustomerResponse400 | restoreCustomerResponse401 | restoreCustomerResponse403 | restoreCustomerResponse404 | restoreCustomerResponse422 | restoreCustomerResponse500) & {
  headers: Headers;
};

export type restoreCustomerResponse = (restoreCustomerResponseSuccess | restoreCustomerResponseError)

export const getRestoreCustomerUrl = (id: string,) => {


  

  return `/customers/${id}/restore`
}

export const restoreCustomer = async (id: string, options?: RequestInit): Promise<restoreCustomerResponse> => {
  
  return customFetch<restoreCustomerResponse>(getRestoreCustomerUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Permanently delete a soft-deleted customer. Only customers in the trash can be permanently deleted.
 * @summary Permanently delete a customer
 */
export type permanentDeleteCustomerResponse204 = {
  data: void
  status: 204
}

export type permanentDeleteCustomerResponse400 = {
  data: Error
  status: 400
}

export type permanentDeleteCustomerResponse401 = {
  data: Error
  status: 401
}

export type permanentDeleteCustomerResponse403 = {
  data: Error
  status: 403
}

export type permanentDeleteCustomerResponse404 = {
  data: Error
  status: 404
}

export type permanentDeleteCustomerResponse422 = {
  data: ValidationError
  status: 422
}

export type permanentDeleteCustomerResponse500 = {
  data: Error
  status: 500
}

export type permanentDeleteCustomerResponseSuccess = (permanentDeleteCustomerResponse204) & {
  headers: Headers;
};
export type permanentDeleteCustomerResponseError = (permanentDeleteCustomerResponse400 | permanentDeleteCustomerResponse401 | permanentDeleteCustomerResponse403 | permanentDeleteCustomerResponse404 | permanentDeleteCustomerResponse422 | permanentDeleteCustomerResponse500) & {
  headers: Headers;
};

export type permanentDeleteCustomerResponse = (permanentDeleteCustomerResponseSuccess | permanentDeleteCustomerResponseError)

export const getPermanentDeleteCustomerUrl = (id: string,) => {


  

  return `/customers/${id}/permanent`
}

export const permanentDeleteCustomer = async (id: string, options?: RequestInit): Promise<permanentDeleteCustomerResponse> => {
  
  return customFetch<permanentDeleteCustomerResponse>(getPermanentDeleteCustomerUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

